// extracted by mini-css-extract-plugin
export var lg = "_4q-4";
export var md = "_4q-3";
export var sm = "_4q-2";
export var xs = "_4q-1";
export var xxs = "_4q-0";